export const openHouseRegistration = {
  meta: {
    title: "Inscrição Dia de Portas Abertas | Gándara International School",
    description: "Reserve o seu lugar no próximo dia de portas abertas. Descubra a nossa metodologia Montessori, instalações e equipa docente.",
  },
  hero: {
    title: "Dia de Portas Abertas",
    subtitle: "Venha conhecer a nossa escola Montessori e inscreva-se na próxima jornada",
    // ── Alterar esta data para futuras jornadas ──
    date: "28 de fevereiro de 2026",
    badge: "Vagas limitadas",
  },
  formTitle: "Reserve o seu lugar",
  formSubtitle: "Preencha os seus dados e confirmaremos a sua presença",
  highlights: {
    title: "O que vai descobrir?",
    items: [
      "A nossa metodologia Montessori em ação",
      "As instalações e espaços naturais",
      "A equipa docente e a sua abordagem pedagógica",
      "O modelo trilingue (espanhol, inglês, galego)",
    ],
  },
};
